import Promise from "bluebird";
import ko from "knockout";
import _ from "lodash";
import loggingService from "services/loggingService";
import HttpError from "util/HttpError";

const requests = [];
const isLoggedIn = ko.observable(false);
const isOAuthSessionExpired = ko.observable(false);

function cancelAllRequests() {
    loggingService.trace("cancelling requests");
    _.each(requests, function (request) {
        loggingService.trace("cancelling request", request);
        request.cancel();
    });
}

function checkForOAuthSessionExpiration(error) {
    if (error.details && error.details.status === 401) {
        isOAuthSessionExpired(true);
    }
    return Promise.reject(error);
}

function clearCompletedRequest(request) {
    const idx = requests.indexOf(request);
    requests.splice(idx, 1);
}

ko.computed(function () {
    if (!isLoggedIn()) {
        cancelAllRequests();
    }
});

/**
 * Tracker for active API requests. Responsible for cancelling all requests
 * on log out and signalling when the user's auth token has expired.
 */
export default {
    addRequest: function (requestPromise) {
        requests.push(requestPromise);
        requestPromise
            .catch(HttpError, checkForOAuthSessionExpiration)
            .finally(function () {
                clearCompletedRequest(requestPromise);
            });
    },

    isLoggedIn: isLoggedIn,
    isOAuthSessionExpired: isOAuthSessionExpired,
};
